import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { supabase, isConfigured } from '../lib/supabase.js'
import { useAuth } from '../context/AuthContext.jsx'
import { useToast } from '../context/ToastContext.jsx'
import Seo from '../components/Seo.jsx'

export default function ResetPassword() {
  const { updatePassword } = useAuth()
  const toast = useToast()
  const navigate = useNavigate()
  const [checked, setChecked] = useState(false) // finished looking for a session
  const [ready, setReady] = useState(false) // recovery / logged-in session present
  const [form, setForm] = useState({ password: '', confirm: '' })
  const [error, setError] = useState('')
  const [busy, setBusy] = useState(false)

  // Supabase (detectSessionInUrl) parses the recovery token from the email link
  // and fires PASSWORD_RECOVERY; a normal logged-in session works too.
  useEffect(() => {
    if (!isConfigured) { setChecked(true); return }
    const { data: sub } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === 'PASSWORD_RECOVERY' || session) { setReady(true); setChecked(true) }
    })
    supabase.auth.getSession().then(({ data }) => {
      if (data.session) setReady(true)
      setChecked(true)
    })
    return () => sub.subscription.unsubscribe()
  }, [])

  const submit = async (e) => {
    e.preventDefault()
    setError('')
    if (form.password.length < 6) return setError('Password must be at least 6 characters.')
    if (form.password !== form.confirm) return setError('Passwords do not match.')
    setBusy(true)
    const res = await updatePassword(form.password)
    setBusy(false)
    if (res.error) return setError(res.error)
    toast('Password updated — you’re logged in.', 'green')
    navigate('/calculator', { replace: true })
  }

  return (
    <main className="page">
      <Seo title="Choose a new password | CalculateMyPeptides" noindex />
      <div className="container auth-wrap">
        <div className="card auth-card fade-in">
          <div className="auth-head">
            <h1>Choose a new password</h1>
          </div>

          {!checked ? (
            <div className="center" style={{ padding: '24px 0' }}><div className="spinner" /></div>
          ) : !ready ? (
            <>
              <div className="form-error" style={{ marginBottom: 12 }}>
                This reset link is invalid or has expired. Request a fresh one below.
              </div>
              <Link to="/forgot-password" className="btn btn-primary btn-block">Request a new link</Link>
            </>
          ) : (
            <form onSubmit={submit}>
              <div className="field">
                <label className="label">New password</label>
                <input className="input" type="password" autoComplete="new-password" required
                  value={form.password} onChange={(e) => setForm((f) => ({ ...f, password: e.target.value }))}
                  placeholder="6+ characters" />
              </div>
              <div className="field">
                <label className="label">Confirm new password</label>
                <input className="input" type="password" autoComplete="new-password" required
                  value={form.confirm} onChange={(e) => setForm((f) => ({ ...f, confirm: e.target.value }))}
                  placeholder="Repeat" />
              </div>
              {error && <div className="form-error" style={{ marginBottom: 12 }}>{error}</div>}
              <button className="btn btn-primary btn-block" type="submit" disabled={busy}>
                {busy ? 'Saving…' : 'Update password'}
              </button>
            </form>
          )}
        </div>
      </div>
    </main>
  )
}
